/* eslint-disable react/prop-types */
// Import packages
import React from 'react';
import { Arrow } from "./style";
var LeftArrow = function LeftArrow(_ref) {
  var previousSlide = _ref.previousSlide,
    preview = _ref.preview;
  return /*#__PURE__*/React.createElement(Arrow, {
    onClick: previousSlide,
    direction: "left",
    preview: preview
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-arrow-left fa-4x",
    "aria-hidden": "true"
  }));
};
export default LeftArrow;